
// 消息能力开关：当前产品仅保留文本、图片和表情（贴纸）消息。
// 如需重新开放某种消息类型，只需在这里将对应开关改为 true。
const MESSAGE_TYPE_SWITCHES = {
	text: true,
	image: true,
	sticker: true,
	file: false,
	audio: false,
	video: false,
	userCard: false,
	groupCard: false,
	mergeForward: false,
	rtcVoice: false,
	rtcVideo: false
};

const MESSAGE_TYPE_SWITCH_MAP = {
	0: 'text',
	1: 'image',
	2: 'file',
	3: 'audio',
	4: 'video',
	5: 'userCard',
	6: 'groupCard',
	7: 'sticker',
	8: 'mergeForward',
	40: 'rtcVoice',
	41: 'rtcVideo'
};

// 是否普通消息
let isNormal = function (type) {
	return type >= 0 && type < 10;
}

// 是否当前版本支持展示和发送的消息
let isSupported = function (type) {
	const switchName = MESSAGE_TYPE_SWITCH_MAP[type];
	return !!(switchName && MESSAGE_TYPE_SWITCHES[switchName]);
}

// 是否状态消息
let isStatus = function (type) {
	return type >= 10 && type < 20;
}

// 是否提示消息
let isTip = function (type) {
	return type >= 20 && type < 30;
}

// 操作交互类消息
let isAction = function (type) {
	return type >= 40 && type < 50;
}

// 单人通话信令
let isRtcPrivate = function (type) {
	return type >= 100 && type < 200;
}

// 多人通话信令
let isRtcGroup = function (type) {
	return type >= 200 && type < 300;
}


export {
	MESSAGE_TYPE_SWITCHES,
	isNormal,
	isSupported,
	isStatus,
	isTip,
	isAction,
	isRtcPrivate,
	isRtcGroup
}
